import { makeStyles } from 'tss-react/mui';
import { GRAY_ALTERNATIVE, PRIMARY_PAYMENT_DEFAULT, WHITE } from 'src/global/theme/colors';

export const stylesList = makeStyles()(() => {
  return {
    tableContainer: {
      backgroundColor: WHITE,
      filter: 'drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.11))',
      borderRadius: '0px 0px 6px 6px',
      // Misma sangría lateral que el panel de filtros y los KPIs.
      margin: '0 40px'
    },
    tableHeader: {
      padding: "24px 0",
      justifyContent: 'space-between',
      width: '100%',
      borderRadius: '6px 6px 0 0',
      backgroundColor: PRIMARY_PAYMENT_DEFAULT,
      color: GRAY_ALTERNATIVE
    }
  };
});
